import { render } from "./PaymentPlans.vue?vue&type=template&id=58779876&scoped=true"
import script from "./PaymentPlans.vue?vue&type=script&lang=ts"
export * from "./PaymentPlans.vue?vue&type=script&lang=ts"

import "./PaymentPlans.vue?vue&type=style&index=0&id=58779876&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58779876"

export default script